import styled from 'styled-components';
import { setFlex, setBackground } from '../../style';

const Hero = styled.div `
    min-height: ${ (props) => props.height ? props.height : '100' }vh;
    ${props => setBackground({ img: props.img, 
                               color: props.bgColor ? props.bgColor :  "rgba(0,0,0,0.2)", 
                               fixed: props.fixed ? '' : 'fixed' }) };
    
    ${setFlex()};
    


`;

export default Hero;